// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"styles_arrowButton__uCtzc","arrow":"styles_arrow__E6clE","chevron":"styles_chevron__ZbUd_"};